import { Node, mergeAttributes } from '@tiptap/core';

// a two-column block: each column holds its own paragraphs, and the PDF prints
// the columns side by side with their lines aligned
export const ColumnsNode = Node.create({
  name: 'columns',
  group: 'block',
  content: 'column column',
  defining: true,
  isolating: true,

  parseHTML() {
    return [{ tag: 'div[data-columns]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-columns': '', class: 'agreement-columns' }), 0];
  },
});

export const ColumnNode = Node.create({
  name: 'column',
  content: 'block+',
  isolating: true,

  parseHTML() {
    return [{ tag: 'div[data-column]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-column': '', class: 'agreement-column' }), 0];
  },
});
